import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/portfolio.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { Portfolio } from "@/types/portfolio";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for makes
  const mock = AxiosMock.getInstance();
  mock.onGet("/carburate/portfolio/").reply(200, data);
}

export const getPortfolio = () => {
  return api.get("/carburate/portfolio/") as Promise<Portfolio>;
};

export const getPortfolioQueryOptions = () => {
  return queryOptions({
    queryKey: ["portfolio"],
    queryFn: getPortfolio,
    staleTime: 0,
    gcTime: 0,
  });
};

type UsePortfolioOptions = {
  queryConfig?: QueryConfig<typeof getPortfolio>;
};

export const usePortfolio = ({ queryConfig }: UsePortfolioOptions = {}) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getPortfolioQueryOptions(),
    ...queryConfig,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
};
